import StoredLayout from '../../layouts/StoredLayout'
import TextWidgets from './TextWidgets'
export default StoredLayout(TextWidgets)
